import { toast } from '@/components/toast';
import md5 from '@/utils/md5';

import { getMixpanel } from '@/services/analytics';
import { LibraryItem } from '@d-id/types';
import { AppRoutes } from './types';
import { getItemPresenterTypeAndLabels } from './utils';

interface ShareInterface {
    itemId: string;
    from?: string;
    type?: 'video' | 'agent';
    clientKey?: string;
}

export function createShareUrl({ itemId, from, type = 'video', clientKey }: ShareInterface) {
    if (type === 'video') {
        return `${window.location.protocol}//${window.location.host}/share?id=${md5(itemId)}&utm_source=${from}`;
    }

    let qs = '';

    if (from) {
        qs += `&utm_source=${from}`;
    }

    if (clientKey) {
        qs += `&key=${btoa(clientKey)}`;
    }

    const url = `${window.location.protocol}//${window.location.host}`;

    return `${url}${AppRoutes.AgentShare}?id=${itemId}` + qs;
}

export function copyToClipboardAsShareUrl({ itemId, type = 'video', ...params }: ShareInterface) {
    copyToClipboard(createShareUrl({ itemId, from: 'copy', type, ...params }));

    toast.success({
        title: 'Link copied successfully',
        toastId: 'copy-to-clipboard-toast',
    });
}

export const copyToClipboard = (url: string) => {
    navigator.clipboard.writeText(url);

    toast.success({
        title: 'Link copied successfully',
        toastId: 'copy-to-clipboard-toast',
    });
};

export interface ShareItem {
    id: string;
    type: string;
}

export function transformToShareItem<T extends { id: string }>(item: T, type: string): ShareItem {
    return {
        id: item.id,
        type,
    };
}

export const sendShareMixpanelEvent = ({ item, to, modal, from }: { item: ShareItem; to: string; modal: string; from?: string }) => {
    const additionalInfo = {
        ...(item.type === 'video' && { videoId: item.id }),
        ...(item.type === 'agent' && { agentId: item.id }),
    };

    getMixpanel()?.track('share-action', {
        event: 'click',
        modal,
        videoId: item.id,
        ...getItemPresenterTypeAndLabels(item as LibraryItem),
        resultType: item.type,
        to,
        ...(from ? { from } : {}),
        ...additionalInfo,
    });
};
